// eslint-disable-next-line import/no-extraneous-dependencies
import VueI18n from 'vue-i18n';
import {
	dateTimeFormats,
	numberFormats,
} from './modules/i18n/formats';
import { FALLBACK_LOCALE, PhoenixLocale } from './modules/i18n/model/locale';
import { getI18nSettingsStore } from './modules/i18n/store/i18nSettings';
import { loadAndSetLocale, loadLocaleMessages } from './modules/i18n/util/loaders';

const i18n = new VueI18n({
	locale: process.env.VUE_APP_I18N_LOCALE || FALLBACK_LOCALE,
	fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || FALLBACK_LOCALE,
	dateTimeFormats,
	numberFormats,
});

export default i18n;

export async function initI18n(i18nInner: VueI18n): Promise<void> {
	const initialLocale = getI18nSettingsStore().getDisplayLocale();
	await Promise.all([
		loadAndSetLocale(i18nInner, initialLocale, true),
		loadLocaleMessages(i18nInner, (process.env.VUE_APP_I18N_FALLBACK_LOCALE as undefined | PhoenixLocale) || FALLBACK_LOCALE),
	]);
}
